import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="text-6xl mb-6">🔍</div>
      <h1 className="text-4xl font-serif font-bold text-[var(--text-primary)] mb-4">
        Page not found
      </h1>
      <p className="text-lg text-[var(--text-secondary)] mb-8 max-w-md">
        We couldn't find what you were looking for. Perhaps the wisdom you seek is elsewhere.
      </p>
      <Link
        to="/"
        className="px-8 py-3 rounded-lg bg-[var(--accent-primary)] text-white font-medium hover:bg-[var(--accent-hover)] transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
};

export default NotFound;
